import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

export interface PrimaryNavItem {
  path: string;
  labelKey: string;
  end?: boolean;
}

export const primaryNavItems = (role: string | null): PrimaryNavItem[] => {
  if (role === 'buyer') {
    return [
      { path: '/', labelKey: 'nav.myJobs', end: true },
      { path: '/hire-a-r8tr', labelKey: 'nav.hireR8tr' },
    ];
  }

  return [
    { path: '/', labelKey: 'nav.dashboard', end: true },
    { path: '/work-profile', labelKey: 'nav.workProfile' },
  ];
};

interface PrimaryNavProps {
  role: string | null;
  direction?: 'row' | 'column';
  onNavigate?: () => void;
}

export const PrimaryNav = ({
  role,
  direction = 'row',
  onNavigate,
}: PrimaryNavProps): JSX.Element => {
  const { t } = useTranslation();
  const items = primaryNavItems(role);

  return (
    <Box
      component="nav"
      sx={{
        display: 'flex',
        flexDirection: direction,
        alignItems: direction === 'row' ? 'center' : 'stretch',
        gap: 0.5,
        minWidth: 0,
      }}
    >
      {items.map((item) => (
        <Box
          key={item.path}
          component={NavLink}
          to={item.path}
          end={item.end}
          onClick={onNavigate}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: direction === 'column' ? 'flex-start' : 'center',
            px: 1.25,
            py: 0.75,
            borderRadius: 0,
            textDecoration: 'none',
            fontSize: 14,
            fontWeight: 600,
            color: 'text.secondary',
            borderBottom: '2px solid transparent',
            '&.active': {
              color: 'text.primary',
              borderBottomColor: 'primary.main',
            },
          }}
        >
          {t(item.labelKey)}
        </Box>
      ))}
    </Box>
  );
};
